var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormula1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFB",
    d: "M9.425 1.286l3.43 6.32c-2.02.349-3.298.632-3.837.849-.241.127.63.828.455 1.016l-.01.01c-.48.966-5.64 3.255-6.041 4.307l-.94-1.607A898.204 898.204 0 0 1 .192 7.92C.58 6.894 1.47 5.673 4.616 4.324 2.713 1.197 8.451 1.499 9.425 1.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M8.91 8.503l.19-.017.421.594c.113.162.192.28.237.351l-.148.096-.7-1.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.533 3.363l2.524 4.347-.192.05c-1.856.455-5.38.482-4.906 2.247a373.53 373.53 0 0 1-3.785-6.341c-.67-2.296 3.38-2.032 5.047-2.5l.105.188-1.908.316 1.146 2.045-.368.052c-.789.116-1.506.261-1.916.467l-1.183-2.05c-.815.364-1.03.935-.598 1.728l.917 1.566c.023-.702.364-1.022.833-1.17l1.205 2.074c-.517.282-.876.659-.746 1.327l1.037 1.783c.138-.47.412-.803.9-.985L7.497 6.439c.631-.372 1.461-.469 2.251-.579l1.168 2.07.84-.136c.37-.062.73-.13 1.055-.218l-1.139-2.05-1.843.29-1.186-2.09 1.89-.363zM2.717 8.129A7.914 7.914 0 0 1 4.87 6.867c.434.682.812 1.406 1.192 2.113l-2.175 1.247-1.17-2.098z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.616 4.324C2.193 5.131.501 6.456 0 7.943l3.615 6.51c1.597-3.853 7.271-3.436 6.114-5.067-.413-.17-.897.373-1.351.62-.368.1-.539-.204-.71-.558l-.53-.94-.38.16a5.96 5.96 0 0 0-.69.342l1.11 2.043c-.92.389-1.595.763-2.16 1.171l-1.135-1.957c-.658.413-1.105.923-1.392 1.715L1.368 9.938c.195-.71.707-1.294 1.336-1.839L1.593 6.08c.62-.523 1.376-.94 2.181-1.242l1.094 2.015L5.9 6.445 4.616 4.324zM8.558.931l5.826 10.26c.107.012.558-.292.616-.384L9.193.55c-.15-.145-.786-.001-.635.38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormula1);
export default __webpack_public_path__ + "static/media/formula1.fdb31872994abb3b968b4c6113e00f48.svg";
export { ForwardRef as ReactComponent };